import React from 'react'
import { times } from 'underscore'


export default class extends React.Component {
    render() {

		return (
			<div className="latest-holder narrow-gutter">
				{ times(5, function(i) {
	        		return <div className="latest-article row full-height" key={'loading-latest-'+i}>
		        		<div className="col-xs-4 col-md-3">
		            		<div className="breathe square"></div>
		    			</div>
		        		<div className="col-xs-8 col-md-9 content-block match-height">
		        			<div className="sub-title breathe"></div>
		        			<div className="sub-title breathe"></div>
		    			</div>
	    			</div>
	    		} ) }
        	</div>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Unfiltered/components/LatestLoading.jsx